import { t } from "@/i18n-js/instance";
import { AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS } from "@circle-react/components/SettingsApp/Workflows/constants";
import { Icon } from "@circle-react-shared/Icon";
import type { ActionOption } from "../../types";
import { useAreAiWorkflowActionsEnabled } from "../reportPost/useAreAiWorkflowActionsEnabled";
import { FormHidePostFromFeaturedAreas } from "./FormHidePostFromFeaturedAreas";
import type { HistoryDetailViewPostHiddenFromFeaturedAreasProps } from "./HistoryDetailViewPostHiddenFromFeaturedAreas";
import { HistoryDetailViewPostHiddenFromFeaturedAreas } from "./HistoryDetailViewPostHiddenFromFeaturedAreas";

export const hidePostFromFeaturedAreas: Readonly<
  ActionOption<HistoryDetailViewPostHiddenFromFeaturedAreasProps>
> = {
  label: t(
    "settings.workflows.form.actions.ai_agents_hide_post_from_featured_areas",
  ),
  textLabel: t(
    "settings.workflows.form.actions.ai_agents_hide_post_from_featured_areas",
  ),
  value: "ai_agents_hide_post_from_featured_areas",
  group: t("settings.workflows.form.action_groups.ai_agents"),
  leftAddon: <Icon type="16-ai-hide" size={16} className="!h-4 !w-4" />,
  formComponent: FormHidePostFromFeaturedAreas,
  viewComponent: null,
  historyDetailViewComponent: HistoryDetailViewPostHiddenFromFeaturedAreas,
  icon: "chat",
  isApplicableToMembersOnly: false,
  availablePlanTier:
    AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS.HIGHER_TIER_PLAN_ONLY,
  released: useAreAiWorkflowActionsEnabled,
} as const;
